@if (inductionConfig?.visitorType) {
<div>
  <div>
    <label class="reasonForVisitLabel" id="reasonForVisitLabel">{{
      "induction_lbl_reasonforvisit" | translate
    }}</label>
  </div>
  <div>
    <label class="joblabel" id="reasonForVisitLabel">{{
      "induction_lbl_reasonforvisit_selectoptions" | translate
    }}</label>
  </div>
  <div class="divider"></div>
  @for (reason of reasonsForVisit; track reason) {
  <div fxLayout="row">
    <div fxLayout="column" fxFlex="100">
      <div class="divider"></div>
      <button
        mat-stroked-button
        id="btn_type{{ reason.id }}"
        (click)="onReasonForVisitSelect(reason)"
        [ngClass]="{ selected: reason.selected, unselected: !reason.selected }"
      >
        <span fxFlex="1 1 auto" fxFlexOrder="1">{{
          reason.displayDescription
        }}</span>
        @if (reason.selected) {
        <mat-icon class="maticon" fxFlex="0 0 auto" fxFlexOrder="2"
          >task_alt</mat-icon
        >
        }
      </button>
    </div>
  </div>
  }
</div>
} @if (inductionConfig?.visitorType == undefined || inductionConfig?.visitorType
== null) {
<div>
  @if (jobsAllocated.length > 0) {
  <div>
    <label class="reasonForVisitLabel" id="reasonForVisitLabel">{{
      "reasonforvisit_lbl_allocatedjob" | translate
    }}</label>
    <div class="divider"></div>
    @for (job of jobsAllocated; track job) {
    <div>
      <div fxLayout="column" fxFlex="100">
        <div fxLayout="row" fxFlex="100">
          <div fxFlex="10">
            <mat-checkbox
              value="{{ job.referenceNumber }}"
              id="job{{ job.referenceNumber }}"
              checked="{{ job.reasonForVisitCheck == true }}"
              (change)="onJobCheck($event.checked, job)"
            >
            </mat-checkbox>
          </div>
          <div fxFlex="90">
            <mat-expansion-panel>
              <mat-expansion-panel-header
                [collapsedHeight]="'auto'"
                [expandedHeight]="'auto'"
                class="expansion-header"
              >
                <mat-panel-title class="name" fxFlex="100">
                  <div
                    fxLayout="row"
                    fxLayoutAlign="space-between"
                    fxFlex="100"
                  >
                    <div
                      fxLayout="column"
                      fxLayoutAlign="space-between"
                      [ngClass]="{
                        flex65: enableUnallocated(job),
                        flex100: !enableUnallocated(job)
                      }"
                    >
                      @if (job.subSite != null) {
                      <div class="joblabel">
                        {{ job.subSite }}
                      </div>
                      }
                      <div class="joblabel color-city-neutral">
                        #{{ job.referenceNumber }}
                      </div>
                      <div class="faultservicelabel color-dark-blue">
                        {{ job.faultServiceName }}
                      </div>
                      @if (job.eta != null) {
                      <div fxLayout="row" fxFlex="100">
                        <div class="job-icon">
                          <mat-icon class="color-city-blue">today</mat-icon>
                        </div>
                        @if (isReactiveJob(job)) {
                        <div class="color-city-blue eta-lbl-font">
                          ETA {{ job.eta | date : "dd-MM-yyyy hh:mm a" }}
                        </div>
                        } @if (isPPMJob(job)) {
                        <div class="color-city-blue eta-lbl-font">
                          Due On {{ job.eta | date : "dd-MM-yyyy" }}
                        </div>
                        }
                      </div>
                      }
                    </div>
                    @if (enableUnallocated(job)) {
                    <div fxFlex="35" fxLayoutAlign="end center">
                      <button
                        mat-flat-button
                        class="unallocatejob"
                        (click)="unallocateJobOnClick(job)"
                        id="btn_unallocate"
                      >
                        {{ "reasonforvisit_lbl_unallocatejob" | translate }}
                      </button>
                    </div>
                    }
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div fxLayout="column" fxFlex="100">
                <div class="expandedheaderlabel color-city-neutral">
                  {{ "common_lbl_department" | translate }}
                </div>
                <div class="expandedlabel color-dark-blue">
                  {{ job.departmentName }}
                </div>
                <div class="expandedheaderlabel color-city-neutral">
                  {{ "common_lbl_notes" | translate }}
                </div>
                <div class="expandedlabel color-dark-blue">
                  {{ job.notes }}
                </div>
              </div>
            </mat-expansion-panel>
            <div class="divider"></div>
          </div>
        </div>
        <mat-divider></mat-divider>
      </div>
    </div>
    }
  </div>
  }
  <div class="divider"></div>
  @if (jobsParentUser.length > 0) {
  <div>
    <label class="reasonForVisitLabel" id="reasonForVisitLabel">{{
      ("reasonforvisit_lbl_parentjob" | translate).replace(
        "{site_name}",
        selectedSite?.name
      )
    }}</label>
    <div class="divider"></div>
    @for (job of jobsParentUser; track job) {
    <div>
      <mat-expansion-panel>
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
          class="expansion-header"
        >
          <mat-panel-title class="name" fxFlex="100">
            <div fxLayout="row" fxLayoutAlign="space-between" fxFlex="100">
              <div fxLayout="column" fxLayoutAlign="space-between" fxFlex="65">
                @if (job.subSite != null) {
                <div class="joblabel">
                  {{ job.subSite }}
                </div>
                }
                <div class="joblabel color-city-neutral">
                  #{{ job.referenceNumber }}
                </div>
                <div class="faultservicelabel color-dark-blue">
                  {{ job.faultServiceName }}
                </div>
                @if (job.eta != null) {
                <div fxLayout="row" fxFlex="100">
                  <div class="job-icon">
                    <mat-icon class="color-city-blue">today</mat-icon>
                  </div>
                  @if (isReactiveJob(job)) {
                  <div class="color-city-blue eta-lbl-font">
                    ETA {{ job.eta | date : "dd-MM-yyyy hh:mm a" }}
                  </div>
                  } @if (isPPMJob(job)) {
                  <div class="color-city-blue eta-lbl-font">
                    Due On {{ job.eta | date : "dd-MM-yyyy" }}
                  </div>
                  }
                </div>
                }
              </div>
              <div fxFlex="35" fxLayoutAlign="end center">
                <button
                  mat-flat-button
                  class="pickup"
                  (click)="pickupJobOnClick(job)"
                  id="btn_pickup"
                >
                  {{ "reasonforvisit_lbl_assignjobtome" | translate }}
                </button>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div fxLayout="column" fxFlex="100">
          <div class="expandedheaderlabel color-city-neutral">
            {{ "common_lbl_department" | translate }}
          </div>
          <div class="expandedlabel color-dark-blue">
            {{ job.departmentName }}
          </div>
          <div class="expandedheaderlabel color-city-neutral">
            {{ "common_lbl_notes" | translate }}
          </div>
          <div class="expandedlabel color-dark-blue">
            {{ job.notes }}
          </div>
        </div>
      </mat-expansion-panel>
      <mat-divider></mat-divider>
      <div class="divider"></div>
    </div>
    }
  </div>
  }
</div>
}
